/* eslint-disable consistent-return */
/**
 * Return the single key whose value is true.
 * Throws if none or more than one true value is found.
 */
const getActiveSortColumn = (flags: Record<string, boolean>): string => {
  const trueKeys = Object.keys(flags).filter((key) => flags[key]);

  if (trueKeys.length === 1) {
    return trueKeys[0];
  }
  if (trueKeys.length === 0) {
    console.warn('No flag is set to true.');
  }
  // more than one true
  console.warn(
    `Expected exactly one true flag, but found ${trueKeys.length}: ${trueKeys.join(', ')}.`
  );
};

export default getActiveSortColumn;
